var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-btn",on:{"click":function($event){return _vm.$router.go(_vm.to)}}},[_c('v-icon',{staticClass:"pointer-events-none"},[_vm._v("mdi-arrow-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }